import React from 'react';
import { Row, Col, Divider } from 'antd';
import moment from 'moment';

import { formatarDataCorrida } from '../../../helpers/formatarDataFila';
import { Indicador } from './Indicador';

export function ColTop({ loading = false, indicResponse }) {
  const corTituloTempoMedio = (tempo, meta) => moment.duration(tempo) >= moment.duration(meta)
      ? '#D42929'
      : '#24A95D';

  return (
    <Row>
      <Col
        style={{
          paddingRight: 8,
          margin: 0,
        }}
        span={6}
      >
        <Indicador
          corTitulo={corTituloTempoMedio(
            indicResponse?.tempoMedioSolicAguardandoFornecedor,
            indicResponse?.metaTempoMedioFornecedor
          )}
          titulo={formatarDataCorrida(
            indicResponse?.tempoMedioSolicAguardandoFornecedor || '00:00:00'
          )}
          subTitulo={`Meta: ${formatarDataCorrida(
            indicResponse?.metaTempoMedioFornecedor || '00:00:00'
          )}`}
          descricao="Tempo médio de fornecedor"
          isLoading={loading}
        />
      </Col>
      <Col
        style={{
          padding: '0 8px',
        }}
        span={12}
      >
        <Row
          justify="center"
          style={{
            background: '#FFFFFF',
            borderRadius: '8px',
          }}
        >
          <Col span={11}>
            <Indicador
              corTitulo={corTituloTempoMedio(
                indicResponse?.tempoMedioSolicitacaoAguardandoAtendimentoInterno,
                indicResponse?.metaTempoMedioFila
              )}
              titulo={
                formatarDataCorrida(
                  indicResponse?.tempoMedioSolicitacaoAguardandoAtendimentoInterno,
                  true
                ) || '00:00:00'
              }
              subTitulo={`Meta: ${indicResponse?.metaTempoMedioFila}`}
              descricao="Tempo médio de fila"
              isLoading={loading}
            />
          </Col>
          <Divider
            type="vertical"
            style={{
              height: 'auto',
              border: '1px solid #E0E0E0',
            }}
          />
          <Col span={11}>
            <Indicador
              corTitulo={corTituloTempoMedio(
                indicResponse?.tempoMedioAtendimento,
                indicResponse?.metaTempoMedioAtendimento
              )}
              titulo={
                formatarDataCorrida(
                  indicResponse?.tempoMedioAtendimento,
                  true
                ) || '00:00:00'
              }
              subTitulo={`Meta: ${indicResponse?.metaTempoMedioAtendimento ||
                '00:00:00'}`}
              descricao="Tempo médio de atendimento"
              isLoading={loading}
            />
          </Col>
        </Row>
      </Col>
      <Col
        style={{
          paddingLeft: 8,
        }}
        span={6}
      >
        <Indicador
          corTitulo={corTituloTempoMedio(
            indicResponse?.maximoTempoAnalise,
            indicResponse?.metaTempoMedioAnaliseTotal
          )}
          titulo={
            formatarDataCorrida(indicResponse?.maximoTempoAnalise, true) ||
            '00:00:00'
          }
          subTitulo={`Meta: ${indicResponse?.metaTempoMedioAnaliseTotal}`}
          descricao="Maior tempo analisando"
          isLoading={loading}
        />
      </Col>
    </Row>
  );
}
